'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import ImageFill from '/public/image-fill.svg';

const ImageError: React.FC = () => {
  const { t } = useTranslation('agent');

  return (
    <div className="absolute left-[19%] right-[19%] top-0 bottom-0 flex flex-col items-center justify-center bg-[#FFFFFF] rounded">
      <ImageFill className="w-[20%] h-auto mb-[7%] text-[#00000040]" />
      <span className="hidden lg:block text-[#00000040] text-sm">
        {t('imageBatchEdit.imageExpired')}
      </span>
    </div>
  );
};

export default ImageError;
